import { UserLocation } from '@/javascript/domain/entities/maps/user-location'
import { RemoteUserLocation } from '@/javascript/data/entities/maps/remote-user-location'
import { ListMapper } from './mapper'

export class UserLocationMapper extends ListMapper<UserLocation, RemoteUserLocation> {
  toEntity (data: RemoteUserLocation): UserLocation {
    return {
      id: data.id,
      name: data.profile?.complete_name,
      email: data.profile?.email,
      photoUrl: data.profile?.photo_url,
      latitude: data.latitude ? parseFloat(data.latitude) : undefined,
      longitude: data.longitude ? parseFloat(data.longitude) : undefined,
      accuracy: data.accuracy,
      maxAccuracy: data.location_accuracy_distance,
      lastSeenAt: data.last_locale_at
    }
  }
}
